export default "__VITE_ASSET__lTSlFiUk__"